import styled from "styled-components";

export const StyledSectionH2 = styled.h2`
  color: ${props => (props.hasColorWhite ? "#fff" : "#222128")};
  font-family: "Proxima Nova Bold";
  font-weight: 700;
  font-size: 36px;
  margin: 0;
`;
